import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import levenshtein from 'fast-levenshtein';
import { OrderService } from './../service/OrderService';

const PotentialInvoices = ({ invoices, selectedOrder, selectedOrderInvoice, linkInvoiceToOrder, unlinkInvoiceFromOrder, viewAll = false}) => {

    // console.log('invoices', invoices);
    // console.log('selectedOrder', selectedOrder);
    // console.log('selectedOrderInvoice', selectedOrderInvoice);
    

    const flattenInvoices = (nestedInvoices) => {
        return nestedInvoices.flat();
    };

    // Your nested invoices
    const nestedInvoices = [
        [{ id: 1 }, { id: 2 }],
        [{ id: 3 }, { id: 4 }],
        // More arrays of invoices
    ];

    // Flattening the array of arrays
    const flattenedInvoices = flattenInvoices(nestedInvoices);

    // Search for an invoice with a specific ID
    const linkedInvoice = flattenedInvoices.find(
        (invoice) => invoice.id === selectedOrder.squareInvoiceID
    );


    const renderLinkButton = (rowData) => {
        return (
            <Button label="Link Invoice" size="small" rounded onClick={() => linkInvoiceToOrder(selectedOrder, rowData)} />
        );
    };


    const renderOpenInvoiceButton = (rowData) => {
        return (
            <>
                <Button label="Open Invoice" size="small" rounded onClick={() => window.open(`https://squareup.com/invoices/${rowData.id}`)} />
                <Button label="Unlink Invoice" size="small" severity="warning" rounded onClick={() => unlinkInvoiceFromOrder(selectedOrder, rowData)} />
            </>
        );
    };

    if (selectedOrder?.squareInvoiceID && 
        selectedOrder?.squareInvoiceID !== '' &&
        selectedOrder?.squareCustomerID &&
        selectedOrder?.squareCustomerID !== '' 
        ) {

        return (
            <div>
                <div style={{
                    //title with padding
                    paddingTop: '0.75rem',
                    paddingBottom: '0.75rem',
                    paddingLeft: '1rem',
                    paddingRight: '1rem',
                    //border
                    border: '1px solid #eaeaea',
                    borderRadius: '10px',
                    //background
                    background: '#2b2b2b',
                    //shadow
                    // boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                    //margin

                    //text
                    textAlign: 'center',
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    color: 'white',
                    //letter spacing
                    letterSpacing: '0.15rem',
                    marginTop: '10px'
                }}>

                    <strong>Linked Invoice</strong>
                </div>
                <div style={{
                    //title with padding
                    paddingTop: '1rem',
                    paddingBottom: '1rem',
                    paddingLeft: '1rem',
                    paddingRight: '1rem',
                    //border
                    border: '1px solid #eaeaea',
                    borderRadius: '10px',
                    //background
                    background: '#f9f9f9',
                    //shadow
                    // boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                    //margin
                    marginBottom: '0.5rem',
                    marginTop: '0.5rem',
                    marginLeft: '0.5rem',
                    marginRight: '0.5rem',
                    //text
                    textAlign: 'center',
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    color: '#333',
                }}>
                    {selectedOrderInvoice ? (
                        <DataTable value={[selectedOrderInvoice.invoice]} size="small">
                            <Column field="invoiceNumber" header="Invoice Number"></Column>
                            <Column field="title" header="Title"></Column>
                            <Column header="Customer Name" body={rowData => `${rowData.primaryRecipient.givenName} ${rowData.primaryRecipient.familyName}`} ></Column>
                            <Column field="primaryRecipient.emailAddress" header="Email"></Column>
                            <Column field="status" header="Status"></Column>
                            <Column header="Action" body={renderOpenInvoiceButton}></Column>
                        </DataTable>
                    ) : (
                        <p>No matching linked invoice found!</p>
                    )}
                </div>
            </div>
        );
    }


    const [firstName, lastName] = selectedOrder?.customer?.name.toLowerCase().split(' ');
    const orderEmail = selectedOrder?.customer?.email.toLowerCase();
    const orderDescriptionWords = selectedOrder?.description.split(' ');
    const orderPhone = selectedOrder?.phone;

    const scoreInvoice = (invoice) => {
        let score = 0;

        if (invoice.primaryRecipient?.givenName.toLowerCase() === firstName && invoice.primaryRecipient?.familyName.toLowerCase() === lastName) {
            score += 6;
        } else if (invoice.primaryRecipient?.givenName.toLowerCase() === firstName) {
            score += 2;
        } else if (invoice.primaryRecipient?.familyName.toLowerCase() === lastName) {
            score += 2;
        }

        if (invoice.primaryRecipient?.emailAddress.toLowerCase() === orderEmail && orderEmail !== '') {
            score += 10;
        }

        if (invoice.primaryRecipient?.phoneNumber === orderPhone && orderPhone !== '') {
            score += 5;
        }

        orderDescriptionWords.forEach(word => {
            if (invoice.title.includes(word)) {
                score += 1;
            }
        });

        return score;
    };

    const scoreInvoice2 = (invoice) => {
        let score = 0;

        const givenName = invoice?.primaryRecipient?.givenName.toLowerCase() || '';
        const familyName = invoice?.primaryRecipient?.familyName.toLowerCase() || '';
        const invoiceEmail = invoice?.primaryRecipient?.emailAddress.toLowerCase() || '';
        const invoicePhone = invoice?.primaryRecipient?.phoneNumber || '';

        if (firstName && lastName) {
            const nameDistance = levenshtein.get(`${givenName} ${familyName}`, `${firstName} ${lastName}`);

            if (nameDistance === 0) {
                score += 6;
            } else if (nameDistance <= 3) {
                score += 2;
            }
        }

        if (orderEmail) {
            const emailDistance = levenshtein.get(invoiceEmail, orderEmail);

            if (emailDistance === 0) {
                score += 10;
            } else if (emailDistance <= 3) {
                score += 3;
            }
        }

        if (orderPhone) {
            const phoneDistance = levenshtein.get(invoicePhone, orderPhone);

            if (phoneDistance === 0) {
                score += 5;
            } else if (phoneDistance <= 3) {
                score += 2;
            }
        }

        if (orderDescriptionWords) {
            orderDescriptionWords.forEach(word => {
                if (invoice.title && invoice.title.includes(word)) {
                    score += 1;
                }
            });
        }

        return score;
    };

    // Define a minimum score threshold for invoices to be considered "potential"
    const minimumScoreThreshold = viewAll ? 0 : 10;

    const sortedInvoices = [...invoices].sort((a, b) => scoreInvoice(b) - scoreInvoice(a));
    const potentialInvoices = invoices.filter(invoice => scoreInvoice(invoice) + scoreInvoice2(invoice) >= minimumScoreThreshold);


    return (
        <>
            <DataTable value={potentialInvoices}>
                <Column field="invoiceNumber" header="Invoice Number" size="small" sortable></Column>
                <Column field="title" header="Title" sortable></Column>
                <Column header="Customer Name" body={rowData => `${rowData.primaryRecipient.givenName} ${rowData.primaryRecipient.familyName}`} ></Column>
                <Column field="primaryRecipient.emailAddress" header="Email" sortable></Column>
                <Column field="status" header="Status" sortable></Column>
                <Column header="Action" body={renderLinkButton}></Column>
            </DataTable>
        </>
    );
};

export default PotentialInvoices;
